import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import NotificationSettings from './NotificationSettings'
import NotificationMessages from './NotificationMessages'
import SystemEvents from './SystemEvents'
import DashboardHeader from '../common/DashboardHeader/DashboardHeader'
import Breadcrumb from '../common/Breadcrumb'
import WrappedTabs from '../../components/common/WrappedTabs'
import './events.scss'

function Events() {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const [activeTab, setActiveTab] = useState(null)
  
  const tabs = useMemo(
    () => [
      {
        id: 1,
        slug: 'system-events',
        label: 'events.system-events',
        component: <SystemEvents />,
      },
      {
        id: 2,
        slug: 'notification-settings',
        label: 'events.notification-settings',
        component: <NotificationSettings />,
      },
      {
        id: 3,
        slug: 'notification-messages',
        label: 'events.notification-messages',
        component: <NotificationMessages />,
      },
    ],
    [],
  )
  
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const contentParam = params.get('content')
    let selectedTab = tabs[0]
    
    if (contentParam) {
      const match = tabs.find((t) => t.slug === contentParam)
      if (match) selectedTab = match
    }
    
    setActiveTab(selectedTab.id)
    const expectedQuery = `?content=${selectedTab.slug}`
    
    if (location.search !== expectedQuery) {
      history.replace({ search: expectedQuery })
    }
  }, [location.search, history, tabs])
  
  const handleChangeTab = (tabId) => {
    const tab = tabs.find((t) => t.id === tabId)
    if (!tab) return
    setActiveTab(tabId)
    history.push({ search: `?content=${tab.slug}` })
  }

  return (
    <div className="events-wrapper">
      <Breadcrumb path={location.pathname} />
      <DashboardHeader headerText={t('nav.events')} />
      <WrappedTabs tabs={tabs.map((e) => ({ id: e.id, name: e.label }))} activeTab={activeTab} changeTab={handleChangeTab} />
      {tabs.find((e) => e.id === activeTab)?.component}
    </div>
  )
}

export default Events
